import { loadableWithFallback } from '@vision/ui/utils';
import type { TreeMapChart1Props } from './TreeMapChart1';

export const TreeMapChart1 = loadableWithFallback<TreeMapChart1Props>(() => import('./TreeMapChart1'));
